module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add":"Added","remove":"Removed","additionalReference":"Additional References","CR":"Customers reference","CU":"Consignee reference"},"no":{"add":"Laget","remove":"Slettet","additionalReference":"Andre Referanser","CR":"Kundes referanse","CU":"Mottakers referanse"}}')
  delete Component.options._Ctor
}
